// APP
import Vue from 'vue';

import store from './store';
import PortalVue from 'portal-vue';

// Import Shared
import '@shared/translations';
import '@shared/filters';
import '@shared/validate';
import '@shared/components';

import router from './router';
import './notifications';
import VueSanitize from 'vue-sanitize';
import App from './App.vue';
import { ignoredElements } from './talentechImport';
import { getHostName, getHostUrl, log } from '@/utils/logging';

Vue.config.productionTip = process.env.NODE_ENV === 'production';

// Portal
Vue.use(PortalVue);

// XSS
let defaults = VueSanitize.defaults;
// Allow images/iframe and setting some limitation to the attributes, thus preventing XSS attacks but allowing img/iframes
defaults.allowedTags = [...defaults.allowedTags, ...['img', 'iframe']];
defaults.allowedAttributes['iframe'] = ['src', 'allowfullscreen', 'frameborder', 'height', 'width'];
if (defaults.allowedAttributes['a']) {
  defaults.allowedAttributes['a'] = [...defaults.allowedAttributes['a'], ...['class', 'data-width', 'data-height']];
}

Vue.use(VueSanitize, defaults);

Vue.config.ignoredElements = ignoredElements;
Vue.filter('stringify', (input) => JSON.stringify(input));
// HTTP
Vue.prototype.$http = require('./http').default;

// ERROR LOGGING
Vue.config.errorHandler = function(err, vm, info) {
  // handle all vue errors
  const messageTemplateValues = [getHostName(), getHostUrl(), err?.message, err?.stack];
  log({ messageTemplateValues: messageTemplateValues, source: 'VUE' });
};

window.onerror = function(message, file, line, col, error) {
  // handle all js errors
  const messageTemplateValues = [getHostName(), getHostUrl(), error?.message];
  log({ messageTemplateValues: messageTemplateValues, messageTemplate: `Error on: {host} {url} {message}` });
  return false;
};

window.onunhandledrejection = (event) => {
  // handle uncaught promises
  if (event?.reason?.response?.status !== 200 && event?.reason?.request?.responseURL?.indexOf('Logs') > -1) {
    return;
  }

  const messageTemplateValues = [getHostName(), getHostUrl(), event?.reason?.message, event?.reason?.stack];
  log({ messageTemplateValues: messageTemplateValues });
};

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
